export default __webpack_public_path__ + "static/media/levtours_black_trans_bg.93b11e26.png";